"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _Typography = require("../Typography");

var _useAvatarIcon = _interopRequireDefault(require("./hooks/useAvatarIcon"));

var _useInitials = _interopRequireDefault(require("./hooks/useInitials"));

var _palette = require("../../modifiers/palette");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var GravatarImg = _styledComponents.default.img.withConfig({
  displayName: "AvatarContent__GravatarImg",
  componentId: "sc-1jejgqy-0"
})(["border-radius:50%;width:100%;"]);

var borderColor = _objectSpread({}, _color.default.base.charcoal, {
  alpha: _palette.BORDER_OPACITY.pastel
});

var GravatarShadow = _styledComponents.default.div.withConfig({
  displayName: "AvatarContent__GravatarShadow",
  componentId: "sc-1jejgqy-1"
})(["position:absolute;width:100%;height:100%;box-shadow:inset 0 0 0 1px ", ";border-radius:50%;top:0;left:0;"], (0, _toColorString.default)(borderColor));

var Initials = (0, _styledComponents.default)(_Typography.P).attrs({
  as: 'span'
}).withConfig({
  displayName: "AvatarContent__Initials",
  componentId: "sc-1jejgqy-2"
})(["font-size:inherit;text-transform:uppercase;font-weight:inherit;"]);

var AvatarIcon = _styledComponents.default.div.withConfig({
  displayName: "AvatarContent__AvatarIcon",
  componentId: "sc-1jejgqy-3"
})([""]);

function AvatarContent(props) {
  var gravatarProps = props.gravatarProps,
      shouldUseGravatar = props.shouldUseGravatar;
  var initials = (0, _useInitials.default)(props);
  var avatarIconProps = (0, _useAvatarIcon.default)(props);

  switch (true) {
    case shouldUseGravatar:
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(GravatarImg, gravatarProps), _react.default.createElement(GravatarShadow, null));

    case !!initials.length:
      return _react.default.createElement(Initials, null, initials);

    default:
      return _react.default.createElement(AvatarIcon, avatarIconProps);
  }
}

var _default = AvatarContent;
exports.default = _default;